export default __webpack_public_path__ + "static/media/github.6a76ea1a.svg";